import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PageComponent } from '@app/v2/components/page/page.component';
import { StudyExpenseTrackerComponent } from '@components/study-expense-tracker/study-expense-tracker.component';

@Component({
    selector: '',
    imports: [StudyExpenseTrackerComponent, PageComponent],
    templateUrl: './set.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetComponent {
    studyId = input.required<number>();
}
